import "@mantine/carousel/styles.css"
import "@mantine/core/styles.css"

import {
  ActionIcon,
  AppShell,
  Burger,
  Button,
  Flex,
  Group,
  rem,
  Stack,
  useComputedColorScheme,
  useMantineColorScheme
} from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { IconMoon, IconSun } from "@tabler/icons-react"
import { Outlet, useNavigate } from "react-router-dom"

export default function App() {
  const navigate = useNavigate()

  const [opened, { toggle }] = useDisclosure()

  const { setColorScheme } = useMantineColorScheme()
  const computedColorScheme = useComputedColorScheme("light", {
    getInitialValueInEffect: true
  })

  return (
    <AppShell
      header={{ height: rem(48), offset: true }}
      navbar={{ width: 300, breakpoint: "sm", collapsed: { desktop: true, mobile: !opened } }}
      transitionDuration={200}
      transitionTimingFunction="ease"
    >
      <AppShell.Header>
        <Group h={"100%"} align={"center"} justify="space-between" px={"md"}>
          <Group>
            <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="md" aria-label="nav-toggle" />
          </Group>

          <Flex gap={0} align={"center"} justify={"center"} visibleFrom="sm">
            <Button variant={"subtle"} color={"dimmed"} onClick={() => navigate("/")} aria-label="downloads">
              Home
            </Button>

            <Button variant={"subtle"} color={"dimmed"} onClick={() => navigate("/about-us")} aria-label="about-us">
              About Us
            </Button>

            <Button variant={"subtle"} color={"dimmed"} onClick={() => navigate("/products")} aria-label="products">
              Products
            </Button>

            <Button variant={"subtle"} color={"dimmed"} onClick={() => navigate("/branches")} aria-label="branches">
              Branches
            </Button>

            <Button variant={"subtle"} color={"dimmed"} onClick={() => navigate("/contact")} aria-label="contact">
              Contact Us
            </Button>
          </Flex>

          <ActionIcon
            size={"sm"}
            variant={"transparent"}
            onClick={() => {
              setColorScheme(computedColorScheme === "dark" ? "light" : "dark")
            }}
            aria-label="toggle-color-scheme"
          >
            {computedColorScheme === "dark" ? <IconMoon size={24} stroke={1.5} /> : <IconSun size={24} stroke={1.5} />}
          </ActionIcon>
        </Group>
      </AppShell.Header>

      <AppShell.Navbar p={"md"}>
        <Stack gap={rem(6)}>
          <Button
            variant={"subtle"}
            color={"dimmed"}
            onClick={() => {
              navigate("/")
              toggle()
            }}
            aria-label="btn-home"
            fullWidth
          >
            Home
          </Button>
          <Button
            variant={"subtle"}
            color={"dimmed"}
            onClick={() => {
              navigate("/about-us")
              toggle()
            }}
            aria-label="btn-about-us"
            fullWidth
          >
            About Us
          </Button>
          <Button
            variant={"subtle"}
            color={"dimmed"}
            onClick={() => {
              navigate("/products")
              toggle()
            }}
            aria-label="btn-products"
            fullWidth
          >
            Products
          </Button>
          <Button
            variant={"subtle"}
            color={"dimmed"}
            onClick={() => {
              navigate("/branches")
              toggle()
            }}
            aria-label="btn-branches"
            fullWidth
          >
            Branches
          </Button>
          <Button
            variant={"subtle"}
            color={"dimmed"}
            onClick={() => {
              navigate("/contact")
              toggle()
            }}
            aria-label="btn-contact-us"
            fullWidth
          >
            Contact Us
          </Button>
        </Stack>
      </AppShell.Navbar>

      <AppShell.Main mx={"auto"} maw={rem(1280)}>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  )
}
